((SuperCollections, $) => {
  "use strict";

  const $dom = {};

  const cacheDom = () => {
    $dom.SuperCollectionsSlider = $(
      "[js-super-collections-slider]"
    );
    $dom.SwatchButtons = $('.swatch__input-radio')
  };

  const bindUIActions = () => {

    $dom.SuperCollectionsSlider.slick({
      slidesToShow: 2,
      slidesToScroll: 2,
      arrows: true,
      dots: true,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 768,
          settings: 'unslick'
        }
      ]
    });

    setTimeout(() => {
      $dom.SwatchButtons.attr('tabindex', '0');
    }, 100);
  };

  const init = () => {
    cacheDom();
    bindUIActions();
  };

  SuperCollections.init = init;
})((window.SuperCollections = window.SuperCollections || {}), jQuery);
